import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { WidgetFacetValueListComponent } from '../widget-facet-value-list/widget-facet-value-list.component';

@Component({
  selector: 'app-formly-facet-value-list-widget',
  templateUrl: './formly-facet-value-list-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    WidgetFacetValueListComponent,
  ]
})
export class FormlyFacetValueListWidgetComponent extends FieldType {

  constructor(
    private cdRef: ChangeDetectorRef,
  ) {
    super();
  }


  ngOnInit(): void {

    // this.getProductId();
    // this.formControl?.valueChanges.subscribe(x => {
    //   this.getProductId();
    // });
  }

}